/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_Profile_LabelInputs */



/**
* | output |
* | --- |
* | "Loudness Profile" |
*
* @param {Audio_Description_Export_Loudness_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_profile_label = /** @type {((inputs?: Audio_Description_Export_Loudness_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil de loudness")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautstärkeprofil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Profilo di rumorosità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профиль громкости")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perfil de sonoridad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("响度曲线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラウドネスプロファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ध्वनि प्रोफ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Perfil de intensidade sonora")
	return /** @type {LocalizedString} */ ("Loudness Profile")
});